
<script lang="ts">

import PlanDetailsComponent from "./PlanDetailsComponent.svelte";
import InsuredDetailsComponent from "./InsuredDetailsComponent.svelte";
import {ApplicationData} from "../../models/ApplicationData";
import OwnerDetailsComponent from "./OwnerDetailsComponent.svelte";
import BeneficiaryInfoComponent from "./BeneficiaryInfoComponent.svelte";
import {createEventDispatcher, onDestroy, onMount} from "svelte";
import {StoredApplicationData} from "../../services/Store";
import {UpdateApplicationRequest} from "../../models/UpdateApplicationRequest";
import {updateApplication} from "../../services/ApplicationDataService";
import {Beneficiary} from "../../models/Beneficiary";
import InforcePolicyComponent from "./InforcePolicyComponent.svelte";
import PendingPolicyComponent from "./PendingPolicyComponent.svelte";
import Modal from "../../components/controls/Modal.svelte"
import {applicationReviewCompleted} from "../../services/NavigationService";

export let applicationData = new ApplicationData();
const dispatch = createEventDispatcher();
const applicationDataUnsubscribe = StoredApplicationData.subscribe(value => applicationData = value);
onDestroy(applicationDataUnsubscribe)
let clonedInsuredDetails = {...applicationData.insuredDetails};
let isLoaded: Boolean = false;
let primaryBeneficiaries: Beneficiary[];
let contingentBeneficiaries: Beneficiary[];
let applicationId: string;
let numberOfEditModeOpen = 0;
let modal;
onMount(() => {
    modal.hide();
})

$: if (applicationData) {
    isLoaded = true;
    primaryBeneficiaries = applicationData.beneficiaries.filter(b => b.isPrimary);
    contingentBeneficiaries = applicationData.beneficiaries.filter(b => !b.isPrimary)
    applicationId = applicationData.applicationId;
    clonedInsuredDetails = {...applicationData.insuredDetails};
}

const continueToNextStep = (event) => {
    event.preventDefault();
    if (numberOfEditModeOpen > 0) {
        modal.show();
        return false;
    }
    window.scrollTo(0,0);
    applicationReviewCompleted();
}


const complete = (event) => {
    event.preventDefault();
    let request = new UpdateApplicationRequest();
    request.insuredDetails = clonedInsuredDetails;
    request.applicationId = applicationData.applicationId;
    request.ownerDetails =  applicationData.ownerDetails;
    request.beneficiaries = applicationData.beneficiaries;
    request.inforcePolicies = applicationData.inforcePolicies;
    request.pendingPolicies = applicationData.pendingPolicies;

    updateApplication(request);
    dispatch('applicationReviewComplete');
}

const yesButtonClicked = (event) => {
   event.preventDefault();
 //   dispatch('applicationReviewCancel', applicationId);
    applicationReviewCompleted();
    dispatch('applicationReviewCancel', applicationId);
}

const modeOnChange = (event) => {
    event.preventDefault();
    if (event.detail) {
        numberOfEditModeOpen++;
    } else {
        numberOfEditModeOpen--;
    }
}

</script>

<div class="application-data-container">
    <div class="card-no-border" style="padding-bottom: 0; margin-bottom:0;">
        <h1>Review my request for Life Insurance</h1>
        <hr/>
        <div>
            Please review the information below provided by your agent. Please take the opportunity to complete any missing information in each section by
            clicking the Edit button. Once you have provided your changes, click the Update button to save your changes.
            Remember the more information you can provide here, the less you will be required to provide to our TeleLife representative later.
        </div>
    </div>
    <div class="info-section">
    </div>
    <div>
        {#if isLoaded}
            <InsuredDetailsComponent insuredDetails={clonedInsuredDetails} on:modeOnChange={modeOnChange}/>
            <PlanDetailsComponent planDetails={applicationData.planDetails}/>
            <OwnerDetailsComponent ownerDetails={applicationData.ownerDetails}/>

            {#if primaryBeneficiaries && primaryBeneficiaries.length > 0}

                {#each primaryBeneficiaries as beneficiary}
                    <BeneficiaryInfoComponent viewBeneficiary={beneficiary} isPrimary={beneficiary.isPrimary}
                                              on:modeOnChange={modeOnChange}/>
                {/each}
            {/if}
            {#if contingentBeneficiaries && contingentBeneficiaries.length > 0}

                {#each contingentBeneficiaries as beneficiary}
                    <BeneficiaryInfoComponent viewBeneficiary={beneficiary} isPrimary={beneficiary.isPrimary}
                                              on:modeOnChange={modeOnChange}/>
                {/each}
            {/if}

            {#if applicationData && applicationData.inforcePolicies && applicationData.inforcePolicies.length > 0}

                {#each applicationData.inforcePolicies as inforcePolicy}
                    <InforcePolicyComponent viewInforcePolicy={inforcePolicy} on:modeOnChange={modeOnChange}/>
                {/each}
            {/if}

            {#if applicationData && applicationData.pendingPolicies && applicationData.pendingPolicies.length > 0}

                {#each applicationData.pendingPolicies as pendingPolicy}
                    <PendingPolicyComponent viewPendingPolicy={pendingPolicy} on:modeOnChange={modeOnChange}/>
                {/each}
            {/if}

        {/if}
    </div>

    <div class="info-section">
        <button class="pl-cta-primary" on:click={continueToNextStep}>CONTINUE TO NEXT STEP</button>
    </div>

</div>
<Modal bind:this={modal}>
    <h3 style="font-family: Open Sans, sans-serif;">
        You have unsaved changes that will be lost if you continue. Please navigate to the section that is in Edit mode and click the Save button if you wish to save your changes.
        <p>Do you wish to continue without saving?</p>
    </h3>

    <div style="padding-top: 2em">
        <button class="pl-cta-primary" on:click={yesButtonClicked}>Yes</button>
        <button class="pl-cta-primary" on:click={() => modal.hide()}>No</button>
    </div>
</Modal>
<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/buttons" as buttons;
  @use "../../../component_scss_library/colors" as colors;
  @use "../../../component_scss_library/fonts" as fonts;

</style>

